import { createSelector } from "reselect";
import { AppState } from "../store";
import { ApprovalsStateI } from "./approvalsTypes";

const selector = (state: AppState) => state.approvalsReducer;

export const approvalsSelector = createSelector([ selector ], (state: ApprovalsStateI) => state);

export const approvalsFiltersSelector = createSelector([ selector ], (state: ApprovalsStateI) => state.filters);

export const approvalsHistoryFiltersSelector = createSelector(
  [ selector ],
  (state: ApprovalsStateI) => state.filtersHistory,
);
